import { ProcesarDatosApi } from "../api/ApiFetch";

const controladorPregunta = "pregunta";

// GET: /pregunta/ObtenerPreguntasPorFormulario/{idFormulario}
export const ObtenerPreguntasPorFormulario = async (idFormulario) => {
    const url = `${controladorPregunta}/ObtenerPreguntasPorFormulario/${idFormulario}`;
    return await ProcesarDatosApi("GET", url);
};

// GET: /pregunta/ObtenerPreguntaPorId/{idPregunta}
export const ObtenerPreguntaPorId = async (idPregunta) => {
    const url = `${controladorPregunta}/ObtenerPreguntaPorId/${idPregunta}`;
    return await ProcesarDatosApi("GET", url);
};

// POST: /pregunta/AgregarPregunta
// Body: { idPregunta?:0, idFormulario, texto, tipo, orden, requerida, activa }
export const AgregarPregunta = async (pregunta) => {
    const url = `${controladorPregunta}/AgregarPregunta`;
    return await ProcesarDatosApi("POST", url, pregunta);
};

// PUT: /pregunta/EditarPregunta
// Body: { idPregunta, idFormulario, texto, tipo, orden, requerida, activa }
export const EditarPregunta = async (pregunta) => {
    const url = `${controladorPregunta}/EditarPregunta`;
    return await ProcesarDatosApi("PUT", url, pregunta);
};

// DELETE: /pregunta/EliminarPregunta/{idPregunta}
export const EliminarPregunta = async (idPregunta) => {
    const url = `${controladorPregunta}/EliminarPregunta/${idPregunta}`;
    return await ProcesarDatosApi("DELETE", url);
};
